
export const theme = {
  colors: {
    background: '#FFFFFF',
    text: '#161615',
    primary: '#f5f5f5'
  }
};
